<p-dialog
  #fastProtocolo
  [modal]="true"
  [visible]="true"
  [position]="'top'"
  (visibleChange)="dialogRef.close()"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
  [maximizable]="true"
  [closable]="true"
  [responsive]="true"
  [closeOnEscape]="false"
  [dismissableMask]="false"
>
  <ng-template pTemplate="header">
    <div class="flex aling-items-center">
      <span class="font-light fs-normal">Adicionar protocolo</span>
      <i class="mdi mdi-receipt-text-outline ml-2 text-primary"></i>
    </div>
  </ng-template>
  <div class="row">
    <div class="col-md-12 mt-3">
      <span class="p-float-label">
        <input
          id="inputtext-nome"
          class="input-filters"
          pInputText
          [formControl]="form.get('nome')"
          (blur)="actionFnCheckEntityExist(form.get('nome'))"
          type="text"
          autocomplete="off"
        />
        <label for="inputtext-nome">Nome *</label>
      </span>
      <small class="p-error" *ngIf="form.get('nome').hasError('duplicate')">
        {{ displayMessage.nome.duplicate }}
      </small>
      <small class="p-error" *ngIf="form.get('nome').hasError('required')">
        {{ displayMessage.nome.required }}
      </small>
      <small class="p-error" *ngIf="form.get('nome').hasError('maxlength')">
        {{ displayMessage.nome.maxlength }}
      </small>
      <small class="p-error" *ngIf="form.get('nome').hasError('isEmptyValue')">
        {{ displayMessage.nome.isEmptyValue }}
      </small>
    </div>
    <div class="col-md-12 mt-3">
      <span class="p-float-label">
        <textarea
          rows="8"
          cols="118"
          pInputTextarea
          style="resize: none;"
          id="inputtext-descricao"
          [formControl]="form.get('descricao')"
          class="input-filters"
        ></textarea>
        <label for="inputtext-descricao">Descrição *</label>
      </span>
      <mat-hint
        class="flex width-100 justify-content-end"
        *ngIf="form.get('descricao').valid"
      >
        {{
          form.controls.descricao.value
            ? form.controls.descricao.value.length
            : 0
        }}/500
      </mat-hint>
      <small
        class="p-error"
        *ngIf="form.get('descricao').hasError('duplicate')"
      >
        {{ displayMessage.descricao.duplicate }}
      </small>
      <small class="p-error" *ngIf="form.get('descricao').hasError('required')">
        {{ displayMessage.descricao.required }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('descricao').hasError('maxlength')"
      >
        {{ displayMessage.descricao.maxlength }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('descricao').hasError('isEmptyValue')"
      >
        {{ displayMessage.descricao.isEmptyValue }}
      </small>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <div class="width-100 mb-3 flex align-items-center justify-content-between">
      <button
        pButton
        pRipple
        severity="danger"
        text
        rounded
        [disabled]="loading"
        (click)="dialogRef.close()"
        label="Cancelar"
        icon="pi pi-fw pi-times-circle"
        iconPos="right"
      ></button>
      <button
        pButton
        pRipple
        severity="success"
        outlined
        rounded
        label="Salvar"
        icon="pi pi-fw pi-save"
        iconPos="right"
        (click)="onSubmit()"
        [disabled]="loading || !form.valid"
      ></button>
    </div>
  </ng-template>
</p-dialog>
